// extracted by mini-css-extract-plugin
export default {"list":"OObzUR","mobileList":"mIuOYl","listPaddingTop":"qNv9YS","basketViewDesktop":"LUt9Tx"};